import React, { Component } from 'react'
import GoalMapBase from '../../../../ui/canvases/GoalMap'
import { withDimensions } from '../helpers';

class GoalMap extends GoalMapBase {
    constructor(props) {
        super(props)
    }

    defaultAvatarSize = () => 72;

    baseConfig = () => {
        const canvasWidth = this.props.width || 200;

        return {
            width: canvasWidth,
            resolution: { width: 1000, height: 1335 },
            line: {
                width: 7,
                dash: 6,
                space: 10,
                arrowHead: {
                    length: 6,
                    filled: true,
                    closed: true,
                },
            },
            strokeStyle: `${this.strokeStyle()}`,
            fillStyle: `${this.fillStyle()}`,
        }
    }
}

export default withDimensions(GoalMap)